let googleChartsPromise;

export function loadGoogleCharts() {
    if (googleChartsPromise) return googleChartsPromise;

    googleChartsPromise = new Promise((resolve, reject) => {
        if (!window.google?.charts) {
            reject(new Error('Google Charts não foi carregado.'));
            return;
        }

        window.google.charts.load('current', {
            packages: ['corechart', 'gantt', 'timeline'],
            language: 'pt-BR'
        });
        window.google.charts.setOnLoadCallback(resolve);
    });

    return googleChartsPromise;
}
